import { surgeTypes } from "./surgeTypes";
import { types } from "../../types/types";

// estados solicitudes
export const getEstadosSolicitudesSurge = (data) => ({ type: surgeTypes.getEstadosSolicitudes, payload: data });
export const cleanEstadosSolicitudesSurge = () => ({ type: surgeTypes.cleanEstadosSolicitudes });

//  conceptos
export const cleanConceptosSurge = () => ({ type: types.cleanConceptosSurge });
export const getConceptosSurge = (data) => ({ type: types.getConceptosSurge, payload: data });
export const insertConceptoSurge = (data) => ({ type: types.insertConceptoSurge, payload: data });
export const updateConceptoSurge = (data) => ({ type: types.updateConceptoSurge, payload: data });
export const removeConceptoSurge = (data) => ({ type: types.removeConceptoSurge, payload: data });

// resoluciones
export const getResolucionesSurge = (data) => ({ type: surgeTypes.getResolucionesSurge, payload: data });

// matriculas
export const getMatriculasSurge = (data) => ({ type: surgeTypes.getMatriculasSurge, payload: data });

// practicas y dispositivos
export const cleanPracticasYDispositivosSurge = () => ({ type: surgeTypes.cleanPracticasYDispositivosSurge });
export const getPracticasYDispositivosSurge = (data) => ({ type: surgeTypes.getPracticasYDispositivosSurge, payload: data });
export const insertPracticasYDispositivosSurge = (data) => ({ type: surgeTypes.insertPracticaYDispositivoSurge, payload: data });
export const updatePracticasYDispositivosSurge = (data) => ({ type: surgeTypes.updatePracticaYDispositivoSurge, payload: data });
export const removePracticasYDispositivosSurge = (id) => ({ type: surgeTypes.removePracticaYDispositivoSurge, payload: id });

// solicitudes
export const getSolicitudesSurge = (data) => ({ type: surgeTypes.getSolicitudesSurge, payload: data });
export const getPaginacionSurge = (data) => ({ type: surgeTypes.getPaginacion, payload: data });
export const getContadorSolicitudesSurge = (data) => ({ type: surgeTypes.getContadorSolicitudesSurge, payload: data });
export const updateSolicitudSurge = (data) => ({ type: surgeTypes.updateSolicitudSurge, payload: data });
export const getTrackingSolicitudSurge = (data) => ({ type: surgeTypes.getTrackingSolicitudSurge, payload: data });
export const cleanTrackingSolicitudSurge = (data) => ({ type: surgeTypes.cleanTrackingSolicitudSurge, payload: data });
export const removeSolicitudSurge = (idSolicitud) => ({ type: surgeTypes.removeSolicitudSurge, payload: idSolicitud });

// archivos
export const cleanArchivosSolicitudesSurge = () => ({ type: surgeTypes.cleanArchivosSolicitudes });
export const getTipoArchivosSurge = (data) => ({ type: surgeTypes.getTipoArchivos, payload: data });
export const getArchivosSolicitudesSurge = (data) => ({ type: surgeTypes.getArchivosSolicitudes, payload: data });
export const uploadArchivoSolicitudSurge = (data) => ({ type: surgeTypes.uploadArchivoSolicitud, payload: data });